import React from 'react';
import { Collapse, Table } from 'antd';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import { uid } from 'uid';

import { IUniversityBall, IUniversitySort } from 'modules/universities';

import { FilterDrawer, FilterSectionDropdown } from '../left-side';

const { Panel } = Collapse;

interface IProps {
  universityBall?: IUniversityBall[];
  sortUniversity?: IUniversitySort[];
}

const SecondSection: React.FC<IProps> = ({ universityBall, sortUniversity }) => {
  const t = useTranslations();
  const { query } = useRouter();
  const { language, study } = query;

  return (
    <div className="rounded-xl bg-white p-3">
      <div className="flex items-center justify-between md:block">
        <h2 className="font-medium">{t('TalimYonalishlari')}</h2>
        <div className="block cursor-pointer md:hidden">
          <div>
            <FilterSectionDropdown sortUniversity={sortUniversity} />
          </div>
          <div className="block sm:hidden">
            <FilterDrawer sortUniversity={sortUniversity} />
          </div>
        </div>
      </div>

      <div className="mt-5 space-y-3">
        <Collapse accordion ghost>
          {universityBall?.map(ball => (
            <Panel
              className="!p-0"
              showArrow={false}
              header={
                <div className="item-center flex justify-between rounded-xl bg-gray-100 p-3 py-4">
                  <span className="font-medium">{ball.direction_name}</span>
                  <div className="flex flex-col items-center gap-3 sm:flex-row">
                    <div className="rounded-full bg-white px-3 py-1 text-xs font-medium text-green-500">{study}</div>
                    <div className="rounded-full bg-white px-3 py-1 text-xs font-medium text-green-500">{language}</div>
                  </div>
                </div>
              }
              key={uid()}
            >
              <Table
                size="small"
                pagination={false}
                dataSource={[ball]}
                rowKey="direction_code"
                className='!mb-3'
                scroll={{
                  x: 'max-content'
                }}
                columns={[
                  {
                    align: 'center',
                    title: t('GrantBall'),
                    dataIndex: 'grant_ball'
                  },
                  {
                    align: 'center',
                    title: t('GrantOrinlari'),
                    dataIndex: 'grant_count'
                  },
                  {
                    align: 'center',
                    title: t('KontraktBall'),
                    dataIndex: 'contract_ball'
                  },
                  {
                    align: 'center',
                    title: t('KontraktOrinlari'),
                    dataIndex: 'contract_count'
                  },
                  {
                    align: 'center',
                    title: `1-${t('Fan').toLowerCase()}`,
                    dataIndex: 'subject_1'
                  },
                  {
                    align: 'center',
                    title: `2-${t('Fan').toLowerCase()}`,
                    dataIndex: 'subject_2'
                  }
                ]}
              />
            </Panel>
          ))}
        </Collapse>
      </div>
    </div>
  );
};

export default SecondSection;
